import axios from "axios";
import { call } from "./";
import { Navigate, useNavigate } from "react-router";
import { showToast } from "../components/toaster/Toaster";
import result from "lodash/result";
// import { toast } from "react-toastify";

const setSession = (accessToken) => {
  if (accessToken) {
    localStorage.setItem("accessToken", accessToken);
  } else {
    localStorage.removeItem("accessToken");
    delete axios.defaults.headers.common.Authorization;
  }
};
const setId = (id) => {
  if (id) {
    localStorage.setItem("Id", id);
  } else {
    localStorage.removeItem("Id");
    delete axios.defaults.headers.common.Authorization;
  }
};

const setPhoneNumber = (phoneNumber) => {
  if (phoneNumber) {
    localStorage.setItem("phoneNumber", phoneNumber);
    console.log("✅ Phone Number stored:", phoneNumber);
  } else {
    localStorage.removeItem("phoneNumber");
    console.log("❌ Phone Number removed");
  }
};

class AuthApi {
  login(data) {
    return new Promise((resolve, reject) => {
      (async () => {
        try {
          const res = await call("post", "login", null, data);

          // Store access token
          const accessToken = res?.data?.token?.accessToken;
          setSession(accessToken);

          // Store ID
          const id = res?.data?.data?.id;
          setId(id);

          // Store phone number
          const phoneNumber = res?.data?.data?.phone || data?.phone;
          setPhoneNumber(phoneNumber);

          // Verify storage
          console.log("📱 Stored Data:", {
            hasAccessToken: !!localStorage.getItem("accessToken"),
            hasId: !!localStorage.getItem("Id"),
            hasPhoneNumber: !!localStorage.getItem("phoneNumber"),
          });

          resolve(res.data);
        } catch (err) {
          console.log(err);
          reject(err);
        }
      })();
    });
  }

  forgotOtp(data) {
    return new Promise((resolve, reject) => {
      (async () => {
        try {
          const res = await call("post", "send-otp", null, data);
          resolve(res.data);
        } catch (err) {
          console.log(err);
          reject(err);
        }
      })();
    });
  }

  verifyOtp(data) {
    return new Promise((resolve, reject) => {
      (async () => {
        try {
          const res = await call("post", "verify-otp", null, data);
          resolve(res.data);
        } catch (err) {
          console.log(err);
          reject(err);
        }
      })();
    });
  }

  resetPassword(data) {
    return new Promise((resolve, reject) => {
      (async () => {
        try {
          const res = await call("put", "update-password", null, data);
          resolve(res.data);
        } catch (err) {
          console.log(err);
          reject(err);
        }
      })();
    });
  }

  updatePassword(data) {
    return new Promise((resolve, reject) => {
      (async () => {
        try {
          const res = await call("post", "check-hash-validity", null, data);
          resolve(res.data);
        } catch (err) {
          console.log(err);
          reject(err);
        }
      })();
    });
  }

  getuserbytoken() {
    return new Promise((resolve, reject) => {
      const token = localStorage.getItem("accessToken");

      (async () => {
        try {
          const res = await call("get", "get-user", null, null, token);

          resolve(res.data);
        } catch (err) {
          if (
            err.response.data.message === "User was logged out from the session"
          ) {
            showToast(err.response.data.message, "error");

            <Navigate to="/login" />;
          }
          resolve(null);
        }
      })();
    });
  }

  logout(params) {
    const token = localStorage.getItem("accessToken");
    return new Promise((resolve, reject) => {
      (async () => {
        try {
          const res = await call("get", "logout", null, params, token);
          setSession();
          setId();
          setPhoneNumber();
          resolve(res.data);
        } catch (err) {
          console.log(err);
          reject(err);
        }
      })();
    });
  }

  // Helper methods to retrieve stored values
  getAccessToken() {
    const token = localStorage.getItem("accessToken");
    console.log("📋 Access Token Retrieved:", token ? "✅ Present" : "❌ Not Found");
    return token;
  }

  getPhoneNumber() {
    const phone = localStorage.getItem("phoneNumber");
    console.log("📱 Phone Number Retrieved:", phone ? "✅ " + phone : "❌ Not Found");
    return phone;
  }

  getId() {
    const id = localStorage.getItem("Id");
    console.log("🆔 ID Retrieved:", id ? "✅ " + id : "❌ Not Found");
    return id;
  }

  // Get all stored user data
  getStoredUserData() {
    return {
      accessToken: localStorage.getItem("accessToken"),
      id: localStorage.getItem("Id"),
      phoneNumber: localStorage.getItem("phoneNumber"),
    };
  }
}

export const authApi = new AuthApi();
